export const list =
[
    [{ 'Vertification': 'one', 'Method': 'MIC-TRC M12-1/2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'two', 'Method': 'MIC-TRC M12-1/3', 'Fx+': 'MI Connstm', 'Fx-': 'Mi conn-stsm' }
    ],
    [{ 'Vertification': 'third', 'Method': 'MIC-TRC M12-1/2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'thirdddd', 'Method': 'MIC-TRC M12223-1/22', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'itdd', 'Method': ' M12-1/2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'isnsjs', 'Method': 'MIC-TRC M2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' }
    ],
    [{ 'Vertification': '1', 'Method': 'MIC-2-1/222', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'autt', 'Method': 'MRC M12-1/112', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'matuu', 'Method': 'MIC-C 2-1/2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'authtt', 'Method': 'RC M12-15/22', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' },
        { 'Vertification': 'fourth', 'Method': ' M12-1/2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' }
    ],
    [{ 'Vertification': '1234', 'Method': 'MIC-TRC M12-1/2', 'Fx+': 'MI Conn', 'Fx-': 'Mi conn-' }]
]